import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBroomWide,
  faHourglassStart,
} from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { t } from "i18next";
import { appointmentStep } from "shared/src/appointment.mjs";
import { faFileEdit } from "@fortawesome/free-solid-svg-icons";

const appointmentStepToLabelData = {
  [appointmentStep.PREPARATION]: {
    icon: faHourglassStart,
    label: "resourceLabel.preparation",
  },
  [appointmentStep.PROCEDURE_NOTES]: {
    icon: faFileEdit,
    label: "resourceLabel.minutes",
  },
  [appointmentStep.CHAIR_CLEANING]: {
    icon: faBroomWide,
    label: "resourceLabel.cleaning",
  },
};

const ResourceLabel = ({ appointmentStep }) => {
  const data = appointmentStepToLabelData[appointmentStep];

  if (data == null) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: "1rem",
        backgroundColor: "elevation.outlined",
        color: "_components.heading.color",
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        marginTop: "3px",
        paddingX: "0.2rem",
        fontSize: "1rem",
        fontWeight: "medium",
      }}
    >
      <FontAwesomeIcon
        icon={data.icon}
        fixedWidth
        style={{ fontSize: "0.9rem" }}
      />
      <Box component="span" sx={{ ml: "0.2rem" }}>
        {t(data.label)}
      </Box>
    </Box>
  );
};

export default ResourceLabel;
